import { takeLatest, put } from "redux-saga/effects";
import * as Sentry from "@sentry/react";
import {
  INITIATE_GET_DASHBOARD_DATA,
  GET_DASHBOARD_DATA_SUCCESS,
  GET_DASHBOARD_DATA_FAIL,
} from "../../actionTypes/dashboard";

// onSuccess handler for dashboard data api
const onDashboardDataSuccess = (payload) => ({
  type: GET_DASHBOARD_DATA_SUCCESS,
  payload,
});

// onFail handler for dashboard data api
const onDashboardDataFail = (payload) => ({
  type: GET_DASHBOARD_DATA_FAIL,
  payload,
});

/**
 * This function handles the dashboard data api and sets the data in reducer accordingly
 *
 * @param {object} action contains the data required for this generator function
 */
function* getDashboardData() {
  try {
    const response = {};
    if (response?.code === 200) {
      yield put(onDashboardDataSuccess(response?.data));
    } else {
      yield put(onDashboardDataFail("Something went wrong"));
    }
  } catch (error) {
    yield put(onDashboardDataFail(error));
    Sentry.captureException(error);
  }
}

/**
 * Watcher saga for Dashboard
 */
function* watchDashboardSaga() {
  yield takeLatest(INITIATE_GET_DASHBOARD_DATA, getDashboardData);
}
export default watchDashboardSaga;
